<template>
	<div>
		<div style="background-color: #FFFFFF;" class="arrow-img"></div>
		<span class="title">为了更好的提供服务</span>
		<span class="title">本公众号已迁移至新的公众号</span>
		<img  :src="qcode" mode="" alt="">
		<span class="tips">长按识别二维码，关注</span>
		<span class="text">关注后书币，会员，阅读记录等信息将迁移至新的公众号</span>
	</div>
</template>

<script>
import {Toast, MessageBox } from "mint-ui";
	export default{
		data(){
			return{
				qcode:''
			}
		},
		mounted() {
			this.getQCode();
		},
		methods:{
			getQCode(){
				this.$api.getQRCodeUrl().then(res=>{
					if(res.status==1){
						this.qcode=res.data;
					}
				})
				
			}
		}
	}
</script>
<style scoped>
	.arrow-img {
		width: 30px;
		height: 44px;
		position: fixed;
		left: 0px;
		top: 0px;
		z-index: 999;
	}
	span{
		display: block;
		text-align: center;
	}
	img{
		display: block;
		width: 150px;
		height: 150px;
		margin:0 auto;
		margin-bottom: 20px;
		margin-top: 33px;
	}
	.title{
		font-size: 18px;
		color: #333333;
		font-weight: bold;
		margin-top: 9px;
	}
	.tips{
		font-size: 15px;
		color: #DE3B34;
	}
	.text{
		font-size: 14px;
		margin-top: 8px;
		color: #888888;
	}
</style>



// WEBPACK FOOTER //
// src/view/QcodeMove/index.vue